import { globalApiService } from '@/store/apis/globalApiSlice';
import { useAppDispatch } from '@/store/hooks';
import { commonActions } from '@/store/slices/commonSlice';
import { carrierActions } from '@/store/slices/main/carrier/carrier-slice';
import { staffDActions } from '@/store/slices/main/dashboard/staffDashboardMyTaskSlice';
import { rolesActions } from '@/store/slices/masters/roles/roleSlice';
import { userActions } from '@/store/slices/masters/user/userApiSlice';
import { userListActions } from '@/store/slices/masters/user/userListSlice';
import { persistor } from '@/store/store';
import { useAuthenticator } from '@aws-amplify/ui-react';
import toast from 'react-hot-toast';

export const useAuth = () => {
  const { user, signOut } = useAuthenticator((context) => [
    context.user,
    context.signOut,
  ]);

  function _signOut() {
    toast.remove();
    signOut();
  }

  return { user, signOut: _signOut };
};

export const useProtectedAuth = () => {
  const dispatch = useAppDispatch();
  const { user, signOut } = useAuthenticator((context) => [
    context.user,
    context.signOut,
  ]);

  function _signOut() {
    toast.remove();
    localStorage.clear();
    persistor.purge();
    dispatch(globalApiService.util.resetApiState());
    dispatch(carrierActions.resetCarrierSlice());
    dispatch(commonActions.resetCommonSlice());
    dispatch(rolesActions.resetRoleSlice());
    dispatch(userActions.reset());
    dispatch(userListActions.reset());
    dispatch(staffDActions.resetStaffDashboardSlice());
    signOut();
  }

  return { user, signOut: _signOut, ogSignOut: signOut };
};
